<script lang="ts" setup>
const InfoBanner = defineAsyncComponent(
  () => import('@/components/InfoBanner/InfoBanner.vue'),
);

const infoBannerStore = useInfoBannerStore();

onMounted(() => {
  const infoBanner = (window.vueAlert ?? [])[0];

  if (infoBanner) {
    infoBannerStore.setData(infoBanner);
  }
});
</script>

<template>
  <RouterView />

  <transition name="fade">
    <InfoBanner
      v-if="infoBannerStore.data"
      :data="infoBannerStore.data"
      @change="infoBannerStore.removeData"
    />
  </transition>
</template>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
